import { IAccordionData } from "@/models/IAccordionData";
import s1Icon1 from "../../assets/icons/capabilities-cde-s1-1.png";
import s1Icon2 from "../../assets/icons/capabilities-cde-s1-2.png";
import s1Icon3 from "../../assets/icons/capabilities-cde-s1-3.png";
import s1Icon4 from "../../assets/icons/capabilities-cde-s1-4.png";
import s1Icon5 from "../../assets/icons/capabilities-cde-s1-5.png";
import s2Icon1 from "../../assets/icons/capabilities-cde-s2-1.png";
import s2Icon2 from "../../assets/icons/capabilities-cde-s2-2.png";
import s2Icon3 from "../../assets/icons/capabilities-cde-s2-3.png";
import s2Icon4 from "../../assets/icons/capabilities-cde-s2-4.png";
import s2Icon5 from "../../assets/icons/capabilities-cde-s2-5.png";
import s3Icon1 from "../../assets/icons/capabilities-cde-s3-1.png";
import s3Icon2 from "../../assets/icons/capabilities-cde-s3-2.png";
import s3Icon3 from "../../assets/icons/capabilities-cde-s3-3.png";
import s3Icon4 from "../../assets/icons/capabilities-cde-s3-4.png";
import s3Icon5 from "../../assets/icons/capabilities-cde-s3-5.png";
import s4Icon1 from "../../assets/icons/capabilities-cde-s4-1.png";
import s4Icon2 from "../../assets/icons/capabilities-cde-s4-2.png";
import s4Icon3 from "../../assets/icons/capabilities-cde-s4-3.png";
import s4Icon4 from "../../assets/icons/capabilities-cde-s4-4.png";
import CapabilitiesTextContainer from "../../components/capabilitiesTextContainer";
import AccordionWrapper from "../../components/accordionWrapper";

const accordionDataRaw: {
  header: string;
  description: string;
  descriptionHeader?: string;
  data: {
    headerSection: string;
    icon: JSX.Element;
    header: string;
    data: string | string[];
  }[];
  description2?: string;
  data2?: {
    headerSection: string;
    icon: JSX.Element;
    header: string;
    data: string[];
  }[];
  description3?: string;
}[] = [
  {
    header: "Clinical Operations",
    description: "",
    data: [
      {
        headerSection: "",
        icon: (
          <img
            src={s1Icon1}
            alt="A magnifying glass and a document"
            className="h-24"
          />
        ),
        header: "Feasibility Assessment",
        data: [
          "Conduct feasibility assessments",
          "Input and options for clinical plans",
        ],
      },
      {
        headerSection: "",
        icon: <img src={s1Icon2} alt="A document" className="h-24" />,
        header: "Clinical Plan Development",
        data: [
          "Consult and develop clinical plans from Phase I to Phase II Proof of Concept (POC)",
          "Advise and provide feedback to optimize clinical plans",
        ],
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s1Icon3}
            alt="A clinical document with a team of people"
            className="h-24"
          />
        ),
        header: "Clinical Trial Design Optimization",
        data: ["Assist in the design of clinical trials"],
      },
      {
        headerSection: "",
        icon: (
          <img src={s1Icon4} alt="Two people shaking hands" className="h-24" />
        ),
        header: "Sponsor Oversight for Trial Conduct",
        data: [
          "Advise sponsors on third party Contract Research Organization (CRO) vendor selection",
          "Act as liaison between sponsor and CRO",
          "Provide sponsor level oversight activities",
        ],
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s1Icon5}
            alt="A document with a pencil and a test tube"
            className="h-24"
          />
        ),
        header: "Trial Data Package",
        data: [
          "Support the development of data package to advance asset to next desired asset milestone",
        ],
      },
    ],
  },
  {
    header: "Medical Advisory Board Support",
    description: "Lilly ExploR&D Providing",
    data: [
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: "Advice on structuring advisory board",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: "Support for Key Opinion Leader (KOL) engagement",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: "Help to assemble pre-work to drive discussions",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: "Advisory board discussion attendance to assist in facilitation and mediation",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "",
        data: "Help to filter KOL feedback to arrive at actionable steps forward",
      },
    ],
    description2: "Lilly ExploR&D Example Disease Areas",
    data2: [
      {
        headerSection: "",
        icon: <></>,
        header: "Discussion topics may include:",
        data: [
          "Indication selection",
          "Protocol design",
          "Biomarker strategy",
          "Efficient trial execution",
        ],
      },
      {
        headerSection: "",
        icon: <img src={s2Icon1} alt="A blood drop" className="h-32" />,
        header: "Diabetes and Obesity",
        data: [],
      },
      {
        headerSection: "",
        icon: <img src={s2Icon2} alt="Antibody" className="h-32" />,
        header: "Immunology",
        data: [],
      },
      {
        headerSection: "",
        icon: <img src={s2Icon3} alt="A cancer cell" className="h-32" />,
        header: "Oncology",
        data: [],
      },
      {
        headerSection: "",
        icon: <img src={s2Icon4} alt="A brain" className="h-32" />,
        header: "Neuroscience",
        data: [],
      },
      {
        headerSection: "",
        icon: <img src={s2Icon5} alt="A DNA strand" className="h-32" />,
        header: "Platforms, including Genetics Medicines",
        data: [],
      },
    ],
    description3: "",
  },
  {
    header: "Clinical Development",
    description: "",
    data: [
      {
        headerSection: "",
        icon: <img src={s3Icon1} alt="A document" className="h-24" />,
        header: "Scientific Rationale and Indication Planning",
        data: "Support with indication selection, target-disease fit, scientific rationale development; provide medical input on the overall clinical development strategy",
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s3Icon2}
            alt="A magnifying glass being used on a document with an outline of three people below"
            className="h-24"
          />
        ),
        header: "Clinical Study Planning",
        data: "Input on patient population, support for study design and monitoring and execution plans",
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s3Icon3}
            alt="A clinical document with a team of people"
            className="h-24"
          />
        ),
        header: "Trial Medical and Safety Monitoring",
        data: "Medical surveillance services with safety oversight, dose escalation guidance, signal detection, ongoing data review",
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s3Icon4}
            alt="A light bulb with a gear over it"
            className="h-24"
          />
        ),
        header: "Ongoing Clinical Asset Support",
        data: "Support for document updates (Investigator Brochure (IB), Development Safety Update Report (DSUR), etc.), regulatory queries",
      },
      {
        headerSection: "",
        icon: (
          <img src={s3Icon5} alt="A graph line going up" className="h-24" />
        ),
        header: "Data Interpretation and Delivery",
        data: [
          "Advise on medical data analysis with recommendations for next steps",
        ],
      },
    ],
  },
  {
    header: "Medical Writing",
    descriptionHeader: "",
    description: "",
    data: [
      {
        headerSection: "",
        icon: <img src={s4Icon1} alt="A cross" className="h-24" />,
        header: "Clinical and Regulatory Support",
        data: [
          "Protocol synopses",
          "Protocols and protocol amendments",
          "Investigator Brochure (IB) and IB updates",
          "Clinical Study Reports (CSRs)",
          "Investigational New Drug (IND)/Clinical Trial Application (CTA) submission package",
          "Regulatory responses",
          "Pre-meeting packages/briefing documents",
          "Development Safety Update Reports (DSURs)",
          "Informed Consent Forms (ICFs)",
        ],
      },
      {
        headerSection: "",
        icon: <img src={s4Icon2} alt="A report" className="h-24" />,
        header: "Document Finalization Support",
        data: [
          "Creation of Electronic Common Technical Document (eCTD)-compliant document",
          "Redaction",
        ],
      },
      {
        headerSection: "",
        icon: <img src={s4Icon3} alt="A checkmark" className="h-24" />,
        header: "Quality Control (QC)",
        data: [
          "Quality control and data source verification checks",
          "Editorial review and document formatting",
          "Consistency and integrity checks across documents",
        ],
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s4Icon4}
            alt="Two publications with a microphone"
            className="h-24"
          />
        ),
        header: "Publications",
        data: ["Scientific manuscripts/abstract"],
      },
    ],
  },
  {
    header: "Statistics & Analytics",
    description: "",
    data: [
      {
        headerSection: "",
        icon: <></>,
        header: "Molecule Screening",
        data: "Integration of multi-dimensional information to prioritize candidates",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Assay Development",
        data: "Optimization, characterization and validation",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Indication Selection",
        data: "Quantitative assessment of potential clinical uses",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Trial Simulation",
        data: "Optimize design based on assumption inputs",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "In Vitro/In Vivo Design",
        data: "Experimental design and data analysis",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Flow Scheme Connectivity",
        data: "Connecting the dots across preclinical studies",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Biomarker Analysis",
        data: "Predictive and prognostic indicators of treatment response",
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Cross-study Comparisons",
        data: "Quantitative integration of results from multiple studies response",
      },
    ],
  },
];
const ClinicalDesignAndExecution = (props: {
  accordionOpenHeader: string;
  setAccordionOpenHeader: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const accordionData: IAccordionData[] = [
    //Clinical Operations
    {
      header: accordionDataRaw[0].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light">
            {accordionDataRaw[0].description}
          </div>
          <div className="my-8 grid xl:grid-cols-3 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[0].data.map((el, index) => (
              <div className="h-full">
                <CapabilitiesTextContainer>
                  <div>
                    <div className="w-full mt-2 mb-4 flex justify-center">
                      {el.icon}
                    </div>
                    <div className="font-medium mb-2">{el.header}</div>
                    <ul className="px-4">
                      {Array.isArray(el.data) &&
                        el.data.map((point) => (
                          <li className="py-1">{point}</li>
                        ))}
                    </ul>
                  </div>
                </CapabilitiesTextContainer>
              </div>
            ))}
          </div>
        </div>
      ),
    },
    //Medical Advisory Board Support
    {
      header: accordionDataRaw[1].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light">
            {accordionDataRaw[1].description}
          </div>
          <div className="my-8 grid xl:grid-cols-5 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[1].data.map((el, index) => (
              <div className="h-full">
                <CapabilitiesTextContainer>{el.data}</CapabilitiesTextContainer>
              </div>
            ))}
          </div>
          <div className="text-xl font-light">
            {accordionDataRaw[1].description2}
          </div>
          <div className="my-8 grid xl:grid-cols-5 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            <div className="h-full">
              <div className="font-medium mb-2">
                {accordionDataRaw[1].data2 &&
                  accordionDataRaw[1].data2[0].header}
              </div>
              <ul className="px-4">
                {accordionDataRaw[1].data2 &&
                  accordionDataRaw[1].data2[0].data.map((point) => (
                    <li className="py-1">{point}</li>
                  ))}
              </ul>
            </div>
            <div className="xl:col-span-4 col-span-1">
              <div className="grid xl:grid-cols-5 grid-cols-2 gap-4 xl:gap-0">
                {accordionDataRaw[1].data2 &&
                  accordionDataRaw[1].data2.map((el, index) => (
                    <>
                      {index > 0 && (
                        <div className="w-full flex flex-col items-center">
                          <div className="font-medium mb-2 text-center">
                            {el.header}
                          </div>
                          {el.icon}
                        </div>
                      )}
                    </>
                  ))}
              </div>
            </div>
          </div>
          <div className="">{accordionDataRaw[1].description3}</div>
        </div>
      ),
    },
    //Clinical Development
    {
      header: accordionDataRaw[2].header,
      body: (
        <div className="px-4 py-4">
          <div className="my-8 grid xl:grid-cols-5 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[2].data.map((el, index) => (
              <div className="h-full">
                <CapabilitiesTextContainer>
                  <div>
                    <div className="w-full mt-2 mb-4 flex justify-center">
                      {el.icon}
                    </div>
                    <div className="font-medium mb-2">{el.header}</div>
                    <div>{el.data}</div>
                  </div>
                </CapabilitiesTextContainer>
              </div>
            ))}
          </div>
        </div>
      ),
    },
    //Medical Writing
    {
      header: accordionDataRaw[3].header,
      body: (
        <div className="px-4 py-4">
          <div className="my-8 grid xl:grid-cols-2 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            <div className="h-full">
              <CapabilitiesTextContainer>
                <div className="grid grid-cols-10">
                  <div className="w-full mt-2 mb-4 flex justify-center md:col-span-2 col-span-10 h-fit">
                    {accordionDataRaw[3].data[0].icon}
                  </div>
                  <div className="md:col-span-8 col-span-10">
                    <div className="font-medium mb-2">
                      {accordionDataRaw[3].data[0].header}
                    </div>
                    <ul className="px-4">
                      {Array.isArray(accordionDataRaw[3].data[0].data) &&
                        accordionDataRaw[3].data[0].data.map((point) => (
                          <li className="py-1">{point}</li>
                        ))}
                    </ul>
                  </div>
                </div>
              </CapabilitiesTextContainer>
            </div>
            <div className="flex flex-col gap-4 xl:gap-2">
              {accordionDataRaw[3].data.map((el, index) => (
                <>
                  {index > 0 && (
                    <div className="h-full">
                      <CapabilitiesTextContainer>
                        <div className="grid grid-cols-10">
                          <div className="w-full mt-2 mb-4 flex justify-center md:col-span-2 col-span-10 h-fit">
                            {el.icon}
                          </div>
                          <div className="md:col-span-8 col-span-10">
                            <div className="font-medium mb-2">{el.header}</div>
                            <ul className="px-4">
                              {Array.isArray(el.data) &&
                                el.data.map((point) => (
                                  <li className="py-1">{point}</li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </CapabilitiesTextContainer>
                    </div>
                  )}
                </>
              ))}
            </div>
          </div>
        </div>
      ),
    },
    //Statistics and Analytics
    {
      header: accordionDataRaw[4].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light max-w-[40rem]">
            {accordionDataRaw[4].description}
          </div>
          <div className="my-8 grid xl:grid-cols-4 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[4].data.map((el, index) => (
              <div className="h-full">
                <CapabilitiesTextContainer>
                  <div className="font-medium mb-2">{el.header}</div>

                  {el.data}
                </CapabilitiesTextContainer>
              </div>
            ))}
          </div>
        </div>
      ),
    },
  ];
  return (
    <AccordionWrapper
      data={accordionData}
      accordionOpenHeader={props.accordionOpenHeader}
      setOpen={props.setAccordionOpenHeader}
    />
  );
};

export default ClinicalDesignAndExecution;
